<template>
  <div class="search-toggle-view-container d-flex align-items-center ml-4">
    <span @click="e => setView(e, 'block')">
      <router-link
        v-tooltip="activeView !== 'block' && `Switch to Grid view`"
        :class="{ 'is-active-view': activeView === 'block' }"
        :to="{ ...$route, name: $route.meta.isGlobalSearch ? 'search' : $route.name }"
        class="btn search-toggle-view fa fa-th-large t-secondary"
      />
    </span>
    <span @click="e => setView(e, 'list')">
      <router-link
        v-tooltip="activeView !== 'list' && `Switch to List view`"
        :class="{ 'is-active-view': activeView === 'list' }"
        :to="{ ...$route, name: $route.meta.isGlobalSearch ? 'search' : $route.name }"
        class="btn search-toggle-view fa fa-th-list t-secondary"
      />
    </span>
    <span @click="e => setView(e, 'landscape')"
      v-if="hasLandscapeView"
    >
      <router-link
        v-tooltip="activeView !== 'landscape' && `Switch to Landscape view`"
        :class="{ 'is-active-view': activeView === 'landscape' }"
        :to="{ ...$route, name: 'searchLandscape' }"
        class="btn search-toggle-view fa fa-area-chart pr-2"
      />
      <span @click.stop class="label-base label-filter-header bg-yellow">NEW</span>
    </span>

  </div>
</template>

<script>
import { mapActions } from 'vuex'
import MPService from '@/services/mixpanel'

export default {
  name: 'searchViewToggler',
  props: {
    activeIndex: {
      type: String,
      required: true
    }
  },
  computed: {
    activeView () {
      const suggestedView = this.searchView(this.activeIndex)

      if (this.$route.meta.isGlobalSearch && this.$route.meta.isLandscape) {
        return 'landscape'
      } else {
        if (suggestedView === 'landscape') {
          return 'block'
        }
        return suggestedView
      }
    },
    hasLandscapeView () {
      const index = this.$route.params.category
      const indexesWithLandscape = ['researchers', 'research_groups', 'organisations']
      if (this.$route.meta.isGlobalSearch && indexesWithLandscape.indexOf(index) > -1) {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapActions('search', [
      'setSearchView'
    ]),
    setView (e, type) {
      e.target.blur()
      MPService.trackEvent('search_view_changed', {
        type: type
      })
      this.setSearchView({ view: type, index: this.activeIndex })
    }
  }
}
</script>
